import React, { Component } from "react";
import styles from "./Demo.module.scss";
import logo from "../../../assets/images/vuppetmaster.png";
import bgCologne from "../../../assets/images/bgCologne.jpg";
import bgPark1 from "../../../assets/images/bgPark1.jpg";
import bgPark2 from "../../../assets/images/bgPark2.jpg";
import bgMall from "../../../assets/images/bgMall.jpg";
import bgWinter from "../../../assets/images/bgWinter.jpg";
import bgFrozen from "../../../assets/images/bgFrozen.jpg";
import bgOffice from "../../../assets/images/bgOffice.jpg";
import bgChristmas from "../../../assets/images/bgChristmas.jpg";
import bgGlitter from "../../../assets/images/bgGlitter.jpg";
import bgForrest from "../../../assets/images/bgForrest.jpg";
import Actions from "../../3_organisms/Actions/Actions";
import ControlPanel from "../../3_organisms/ControlPanel/ControlPanel";
import Toolbar from "../../3_organisms/Toolbar/Toolbar";
import Script from "react-load-script";
import Progress from "../../1_atoms/Progress/Progress";
import Effect from "../../1_atoms/Effect/Effect";
import { cx } from "../../../helpers/ClassNames.helper";

class Demo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: null,
      voices: [
        { title: "Joanna EN", voice: "Joanna", language: "EN" },
        { title: "Matthew US", voice: "Matthew", language: "EN" },
        { title: "Vicki DE", voice: "Vicki", language: "DE" },
        { title: "Hans DE", voice: "Hans", language: "DE" }
      ],
      avatarIndex: 0,
      avatars: [
        { title: "Gloria", key: "A733M-L91TW-FQL81-KFH76" },
//        { title: "Mika", key: "VUYLH-DQ7EG-5385A-1X97A" }
      ],
      website: null,
      websites: [
        { title: "---", url: "" },
        { title: "www.charamel.com", url: "https://www.charamel.com" },
        { title: "www.dfki.de", url: "https://www.dfki.de" },
        { title: "www.bmbf.de", url: "https://www.bmbf.de" },
        { title: "www.ard.de", url: "https://www.ard.de" },
        { title: "www.rtl.de", url: "https://www.rtl.de" }
      ],
      background: bgOffice,
      backgrounds: [
        { title_translate: "background.Office", image: bgOffice },
        { title_translate: "background.Cologne", image: bgCologne },
        { title_translate: "background.Park", image: bgPark1 },
        { title_translate: "background.CityPark", image: bgPark2 },
        { title_translate: "background.Mall", image: bgMall },
        { title_translate: "background.Winter", image: bgWinter },
        { title_translate: "background.Frozen", image: bgFrozen },
        { title_translate: "background.Christmas", image: bgChristmas },
        { title_translate: "background.Pop", image: bgGlitter },
        { title_translate: "background.Forrest", image: bgForrest }
      ],
      effectIndex: 0,
      effects: [
        { title_translate: "effect.none", value: null },
        { title_translate: "effect.snow", value: "snow" },
        { title_translate: "effect.confetti", value: "confetti" },
        { title_translate: "effect.stars", value: "stars" },
        { title_translate: "effect.twinkle", value: "twinkle" }
      ]
    };

    let currentX = 0;
    let currentY = 0;
    let targetX = 0;
    let targetY = 0;
    let animating = false;

    const animateBackground = () => {
      animating = true;

      if (this.backgroundRef) {
        currentX += (targetX - currentX) / 10;
        currentY += (targetY - currentY) / 10;
        this.backgroundRef.style.transform = `translate(${currentX}%, ${currentY}%)`;
      } else {
        currentX = targetX;
        currentY = targetY;
      }

      if (
        Math.abs(currentX - targetX) > 0.01 &&
        Math.abs(currentY - targetY) > 0.01
      ) {
        requestAnimationFrame(animateBackground);
      } else {
        animating = false;
      }
    };

    document.addEventListener("mousemove", event => {
      if (this.backgroundRef) {
        targetX = (event.clientX / window.innerWidth - 0.5) * 2;
        targetY = (event.clientY / window.innerHeight - 0.5) * 1;

        if (!animating) {
          animateBackground();
        }
      }
    });
  }

  handleScriptCreate() {}

  handleScriptError() {
    this.setState({ scriptError: true });
  }

  handleScriptLoad() {
    this._vuppetmaster = new window.VM.Vuppetmaster();
    this._vuppetmaster.on("complete", () => {
      var list = this._vuppetmaster.models.get()[0].getMorphtargets();
      let morphArray = list.map(item => ({
        key: item,
        text: item,
        value: item
      }));

      this.setState({
        ...this.state,
        morphArray,
        visible: true,
        initialRender: true,
        progress: null,
        camera: "start"
      });
    });
    this._vuppetmaster.on("progress", data => {
      this.setState({
        ...this.state,
        progress: data.value * 100
      });
    });
    this._vuppetmaster.start({
      app:'vuppetmaster-demo'
    });
    document._vuppetmaster = this._vuppetmaster;
  }

  changeCamera(name) {
    this._vuppetmaster.cameras.setByName(name);
    this.setState({
      ...this.state,
      camera: name
    });
  }

  updateCamera(modificationCallback) {
    const cameraData = this._vuppetmaster.getCamera();
    const newData = modificationCallback({ ...cameraData });
    this._vuppetmaster.setCamera(newData);
    this.setState({
      ...this.state,
      camera: { ...this.state.camera, data: newData }
    });
  }

  setBackground(image) {
    this.setState({
      ...this.state,
      background: image,
      website: null
    });
  }

  setEffect(index) {
    this.setState({
      ...this.state,
      effectIndex: index
    });
  }

  setWebsite(index) {
    const url = this.state.websites[index] && this.state.websites[index].url;
    this.setState({
      ...this.state,
      website: url && (/^https?:\/\//i.test(url) ? url : `https://${url}`)
    });
  }

  setAvatar(index) {
    if (index !== this.state.avatarIndex) {
      this._vuppetmaster.destroy();
      this.setState({
        ...this.state,
        visible: false,
        avatarIndex: index,
        // \/ fixes caching issues with the script loader
        avatarChangeCounter: (this.state.avatarChangeCounter || 0) + 1
      });
    }
  }

  speak(message, voice) {
    if (!message || message.length === 0) return false;
    if (message.length === 1 && typeof message[0] === "object") {
      this.playEmote(message[0], true);
      return true;
    }

    const text = message
      .map((m, index) =>
        typeof m === "string"
          ? m
          : `<mark name="${index}"/><break time="${Math.round(m.duration)}ms"/>`
      )
      .join(" ");

    const handleEmotions = response => {
      if (response && response.result === "ok") {
        for (let i = 0; i < response.data.length; i++) {
          if (
            response.data[i].marker != null &&
            message[Number(response.data[i].marker)]
          ) {
            const action = message[Number(response.data[i].marker)];
            setTimeout(() => {
              this.playEmote(action);
            }, response.data[i].time);
          }
        }
      }
    };

    if (this._vuppetmaster) {
      this._vuppetmaster.core.stopAnimation();

      this._vuppetmaster.tts.speak(
        { 
          text: `${text}`, 
          voice,
          visemeCB: (response) => handleEmotions(response)
        },
        response => console.log("speak finished"),
        handleEmotions
      );
    }
  }

  playEmote(action, stopScript = false) {
    if (this._vuppetmaster) {
      if (stopScript) {
        this._vuppetmaster.core.stopAnimation();
      }
      if (action.emotion) {
        this._vuppetmaster.models.playEmotion(action.emotion.toLowerCase(), 1000,1000);
      } else if (action.motion) {
        this._vuppetmaster.models.playMotion(action.motion);
      }
    }
  }

  playScript(scriptId) {
    if (this._vuppetmaster) {
      if (scriptId) {
        this._vuppetmaster.core.setCurrentLanguage(this.props.language);
        this._vuppetmaster.core.playAnimationByName(
          scriptId
        );
      }
    }
  }

  render() {
    const { language } = this.props;

    const {
      visible,
      initialRender,
      progress,
      avatars,
      avatarIndex,
      avatarChangeCounter,
      voices,
      camera,
      websites,
      website,
      backgrounds,
      background,
      effects,
      effectIndex
    } = this.state;

    return (
      <div className={styles.host}>
        {initialRender && background && !website && (
          <div
            ref={ref => (this.backgroundRef = ref)}
            className={styles.backgroundImage}
            style={{ backgroundImage: `url(${background})` }}
          />
        )}
        {website && (
          <iframe title={website} className={styles.website} src={website} />
        )}
        {!visible && (
          <div className={styles.progress}>
            {!initialRender && (
              <img className={styles.logo} src={logo} alt="VuppetMaster" />
            )}
            <Progress value={progress} />
          </div>
        )}
        {effectIndex > 0 && effects[effectIndex] && (
          <Effect active={effects[effectIndex].value} />
        )}
        <Script
          // avatarChangeCounter fixes caching issues when changing back to an already loaded script
          key={avatars[avatarIndex].key + avatarChangeCounter}
          url={`https://vuppetmaster.de/vmapi/v4/api?key=C7Y6E-P74SB-NQNVF-94N84`}
                    //url={`http://localhost:9443/vmapi/v4.local/api?key=C7Y6E-P74SB-NQNVF-94N84`}
          onCreate={this.handleScriptCreate.bind(this)}
          onError={this.handleScriptError.bind(this)}
          onLoad={this.handleScriptLoad.bind(this)}
        />

        <div className={styles.container} id="webglcontainer" />

        {initialRender && (
          <div className={styles.actions}>
            <Actions
              playScript={this.playScript.bind(this)}
              language={language}
            />
          </div>
        )}
        {initialRender && (
          <div className={styles.control}>
            <ControlPanel
              voices={voices}
              avatars={avatars}
              websites={websites}
              effects={effects}
              backgrounds={backgrounds}
              setAvatar={this.setAvatar.bind(this)}
              setBackground={this.setBackground.bind(this)}
              setEffect={this.setEffect.bind(this)}
              setWebsite={this.setWebsite.bind(this)}
              speak={this.speak.bind(this)}
              playEmote={this.playEmote.bind(this)}
            />
          </div>
        )}
        {initialRender && (
          <div className={styles.toolbar}>
            <Toolbar
              camera={camera}
              changeCamera={this.changeCamera.bind(this)}
              updateCamera={this.updateCamera.bind(this)}
            />
          </div>
        )}
      </div>
    );
  }
}

export default Demo;
